// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3ygY7","containerItemsCenter":"Skeleton_containerItemsCenter__3ZqZ2"};